var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEfficiencyAndSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 92,
    viewBox: "0 0 90 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9432 46.6768L51.0657 61.1143L66.9991 63.4295L55.4696 74.6673L58.1914 90.5324L43.9432 83.0406L29.6919 90.5324L32.4167 74.6673L20.8872 63.4295L36.8175 61.1143L43.9432 46.6768Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0653 73.8693L15.2544 69.2357L6.44355 73.8693L8.12876 64.0591L1 57.1103L10.8505 55.6796L15.2544 46.7539L19.6614 55.6796L29.5119 57.1103",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0009 73.8693L73.8117 69.2357L82.6226 73.8693L80.9374 64.0591L88.0661 57.1103L78.2156 55.6796L73.8117 46.7539L69.4078 55.6796L59.5542 57.1103",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3924 16.3555H24.6484C23.8925 16.3555 23.2798 16.9682 23.2798 17.7241V38.9552C23.2798 39.7111 23.8925 40.3239 24.6484 40.3239H31.3924C32.1482 40.3239 32.761 39.7111 32.761 38.9552V17.7241C32.761 16.9682 32.1482 16.3555 31.3924 16.3555Z",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8945 34.7285C35.5294 40.4545 41.9164 40.1938 43.4309 40.1938H58.7033C60.5468 40.1938 62.052 38.7041 62.052 36.8855C62.052 35.0668 60.5437 33.5771 58.7033 33.5771H54.6036",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2831 27.4199H59.7956C61.487 27.4199 62.8712 28.8041 62.8712 30.4955C62.8712 32.1869 61.487 33.5711 59.7956 33.5711H54.3955",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1737 21.1904H60.6862C62.3777 21.1904 63.7618 22.5746 63.7618 24.266C63.7618 25.9574 62.3777 27.3416 60.6862 27.3416H55.2861",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0249 19.189C33.0249 19.189 37.5684 18.2673 40.5975 11.9454C43.6265 5.62356 44.8772 1.08002 44.8772 1.08002C44.8772 1.08002 47.9062 0.158278 49.4207 4.57147C50.9353 8.98466 48.17 14.9868 48.17 14.9868L61.2979 15.0396C62.9893 15.0396 64.3734 16.4238 64.3734 18.1152C64.3734 19.8066 62.9893 21.1908 61.2979 21.1908H55.8978",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1401 20.1387V24.6574",
    stroke: "#257239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiencyAndSafety);
export default __webpack_public_path__ + "static/media/efficiency-and-safety.1a9874644286aef49e63ac47b81112ee.svg";
export { ForwardRef as ReactComponent };